export const META_DESCRIPTION_MIN_LENGTH = 70;
export const META_DESCRIPTION_MAX_LENGTH = 160;

function cleanText(value: string): string {
  return value
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/<[^>]*>/g, " ")
    .replace(/[*_`#]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function truncateAtWordBoundary(value: string, limit: number): string {
  if (value.length <= limit) return value;
  const candidate = value.slice(0, Math.max(1, limit - 1));
  const boundary = candidate.lastIndexOf(" ");
  return `${(boundary > 45 ? candidate.slice(0, boundary) : candidate).trimEnd()}…`;
}

/**
 * Keeps public page descriptions useful for search results and social cards.
 * It deliberately preserves supplied wording where it already falls in the
 * recommended range, rather than fabricating claims or changing editorial facts.
 */
export function normaliseMetaDescription(description: string, title: string): string {
  const cleanedDescription = cleanText(description);
  if (cleanedDescription.length >= META_DESCRIPTION_MIN_LENGTH && cleanedDescription.length <= META_DESCRIPTION_MAX_LENGTH) {
    return cleanedDescription;
  }
  if (cleanedDescription.length > META_DESCRIPTION_MAX_LENGTH) {
    return truncateAtWordBoundary(cleanedDescription, META_DESCRIPTION_MAX_LENGTH);
  }

  const subject = cleanText(title) || "this Integrated.Social resource";
  const fallback = `Explore ${subject}: evidence-led guidance for marketing leaders on AI search, responsible adoption and practical next steps.`;
  return truncateAtWordBoundary(fallback, META_DESCRIPTION_MAX_LENGTH);
}
